angular.module('skeyenoteWebApp').directive('dropdownInput', dropdownInputDirective);

function dropdownInputDirective() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      element.bind('click', function(event) {
        event.stopPropagation();
      });
    },
  };
}
